export enum ScenarioMessageTypes {
	MESSAGE = "MESSAGE",
	DECISION = "DECISION",
	END = "END",
	SERVICE = "SERVICE",
}
